import React from 'react'
import PropTypes from 'prop-types'

import Navbar from '../Navbar/Navbar'
import { HeaderLayout } from './Header.styled'
import SkipLinks from '../SkipLinks/SkipLinks'
import Drawer from '../Drawer/Drawer'

const Header = ({ companyNavigation, profilNavigation, light, scroll }) => {
  return (
    <HeaderLayout $scroll={scroll} role="banner">
      <SkipLinks />
      <Navbar
        companyNavigation={companyNavigation}
        profilNavigation={profilNavigation}
        light={light}
        scroll={scroll}
      />
      <Drawer companyNavigation={companyNavigation} profilNavigation={profilNavigation} />
    </HeaderLayout>
  )
}

Header.propTypes = {
  companyNavigation: PropTypes.array.isRequired,
  profilNavigation: PropTypes.array.isRequired,
}

export default Header
